exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.active[data-v-4ca2e4d5] {\n  color: black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4ca2e4d5&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/VLink.vue
// module id = 74
// module chunks = 0